import {createAction} from 'web-app/util/redux/famly-app-helpers';

import type * as Models from './models';

const domain = 'GROUP_CHART';

export const {
    action: fetchGroupChartData,
    success: fetchGroupChartDataSuccess,
    failed: fetchGroupChartDataFailed,
} = createAction(
    `${domain}/FETCH_GROUP_DATA`,
    (groupIds: string[]) => ({groupIds}),
    (chartData: Models.ChartDataFromAPI) => ({chartData}),
);

export const {
    action: fetchTagChartData,
    success: fetchTagChartDataSuccess,
    failed: fetchTagChartDataFailed,
} = createAction(
    `${domain}/FETCH_TAG_DATA`,
    (tagId: string) => ({tagId}),
    (chartData: Models.ChartDataFromAPI) => ({chartData}),
);

export const {action: reset} = createAction(`${domain}/RESET`, () => ({}));
